import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HeaderAndMenuModule } from 'src/app/shared/header-and-menu/header-and-menu.module';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';

//import { AppRoutingModule } from 'src/app/app-routing.module';
import { RouterModule } from '@angular/router';
import { LeftMenuModule } from 'src/app/shared/left-menu/left-menu.module';
import { AdminLayoutComponent } from './admin-layout.component';

@NgModule({
    declarations: [AdminLayoutComponent],
    imports: [
        CommonModule,
        HeaderAndMenuModule,
        LeftMenuModule,
        MatToolbarModule,
        MatExpansionModule,
        MatSidenavModule,
        MatButtonModule,
        MatDividerModule,
        MatCardModule,
        MatMenuModule,
        MatIconModule,
        RouterModule,
    ],
})
export class AdminLayoutModule {}
